import { StyledAuthHeader } from './styled';

import logo from 'assets/images/admin/logo_mxcampus2.png';

export const AuthHeader = () => {
  return (
    <StyledAuthHeader>
      <img src={logo} />
      <span>Meta eXperience Campus</span>
    </StyledAuthHeader>
  );
};
